import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import Helmet from "react-helmet";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import headersList from "../../../../../../Constants/headersList";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DAYS_LIST from "../../../../../../Constants/DATA/daysList";
import { getSelectValue } from "../../../../../../Utils";
import { getFinancialcycle } from "./functions";

class Expensecycle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthcutoffday: "",
      processingday: "",
      transitionperiod: "",
      subscriptionid: "",
    };
    this.onSave = this.onSave.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getExpenseCycleData = this.getExpenseCycleData.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getFinancialCycleData = this.getFinancialCycleData.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("expenseCycle");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getExpenseCycleData();
        setTimeout(() => this.getFinancialCycleData(), 1000);
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  onChange(e, key) {
    this.setState({ [key]: e.target.value });
  }

  onSelect(e, key) {
    this.setState({ [key]: e.displayvalue });
  }

  getFinancialCycleData() {
    const URL = `account/globledefault/${get(
      this.props,
      "SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const obj = { month: result.data.result[0].financialcycleid };
        const financialdate = getFinancialcycle(obj);
        this.setState({
          financialdate,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getExpenseCycleData() {
    instance
      .get("expense/expensecycle")
      .then((result) => {
        this.setState({
          monthcutoffday: get(result, "data.result[0].monthcutoffday", ""),
          processingday: get(result, "data.result[0].processingday", ""),
          transitionperiod: get(result, "data.result[0].transitionperiod", ""),
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onSave() {
    if (
      !this.state.monthcutoffday ||
      !this.state.processingday ||
      !this.state.transitionperiod
    ) {
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
    } else {
      const data = {
        monthcutoffday: this.state.monthcutoffday,
        processingday: this.state.processingday,
        transitionperiod: this.state.transitionperiod,
      };
      const URL = `expense/expensecycle`;
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Saved Successfully", {
            variant: "success",
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  UpdateDays(event) {
    let transitionperiod;
    if (Number.isNaN(event.target.value) || parseInt(event.target.value) > 90) {
      transitionperiod = "";
    } else {
      transitionperiod = event.target.value;
    }
    this.setState({ transitionperiod });
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.ExpenseCycle.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <Grid container className="expense-outer width50">
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <span className="page-header-name">
                  Expense Cycle Processing
                </span>
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <div className="margin-bottom-32">
                <p className="sub-heading">
                  When does your monthly expense cycle end?
                </p>
                <p className="input-label">End date</p>
                <span className="inline-display">
                  <Select
                    className="expense-cycle-input"
                    placeholder="Select Day"
                    options={DAYS_LIST}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={(e) => this.onSelect(e, "monthcutoffday")}
                    disabled={
                      this.state.permissions && !this.state.permissions.editable
                    }
                    value={getSelectValue(DAYS_LIST, this.state.monthcutoffday)}
                  />
                </span>
                <span className="every-month-text-show">of every month</span>
                <p
                  className="input-label"
                  style={{ width: "75%", marginTop: 8 }}
                >
                  Note: If selected date is not present in a month, the
                  effective date will be the last day of that month.
                </p>
              </div>
              <div className="margin-bottom-32">
                <p className="sub-heading">
                  When do you process your expenses?
                </p>
                <p className="input-label">Processing date</p>
                <span className="inline-display">
                  <Select
                    className="expense-cycle-input"
                    placeholder="Select Day"
                    options={DAYS_LIST}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={(e) => this.onSelect(e, "processingday")}
                    disabled={
                      this.state.permissions && !this.state.permissions.editable
                    }
                    value={getSelectValue(DAYS_LIST, this.state.processingday)}
                  />
                </span>
                <span className="every-month-text-show">of every month</span>
                <p
                  className="input-label"
                  style={{ width: "75%", marginTop: 8 }}
                >
                  Note: If selected date is not present in a month, the
                  effective date will be the last day of that month.
                </p>
              </div>
              <div className="margin-bottom-32">
                <p className="sub-heading">
                  Transition period allows employees to file expenses from the
                  last expense cycle. How long would you like this period to be?
                </p>
                <p className="input-label">Transition period</p>
                <TextField
                  className="expense-cycle-input"
                  margin="dense"
                  variant="outlined"
                  placeholder="Enter number of days"
                  onChange={this.UpdateDays.bind(this)}
                  value={this.state.transitionperiod}
                  disabled={
                    this.state.permissions && !this.state.permissions.editable
                  }
                  type="number"
                  min="0"
                  max="90"
                />
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Grid container className="margin-bottom-32">
                <Grid item xs={12} md={8} sm={8}>
                  <div className="text-center">
                    <p className="text-copy">Annual cycle</p>
                    <div
                      style={{
                        background: "#d9dadb",
                        marginTop: 8,
                        padding: 2,
                      }}
                    >
                      <span className="text-copy">
                        {this.state.financialdate}
                      </span>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4} sm={4}>
                  <div className="text-center margin-left-2">
                    <p className="text-copy">Transition period</p>
                    <div
                      className={
                        this.state.transitionperiod &&
                        this.state.transitionperiod
                          ? "transitionperiod-data"
                          : "transition-period-empty"
                      }
                    >
                      <span className="text-copy">
                        {this.state.transitionperiod
                          ? this.state.transitionperiod
                          : 0}{" "}
                        Day(s)
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {this.state.permissions && this.state.permissions.editable && (
              <Grid item xs={12} md={12} sm={12}>
                <Button
                  className="margin-top-20"
                  style={{ width: 140 }}
                  color="primary"
                  variant="contained"
                  onClick={this.onSave}
                >
                  Save
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );
  }
}

Expensecycle.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(Expensecycle)));
